import React, { useState } from 'react';
import SectionHeader from '../components/SectionHeader';
import ServiceDetailModal from '../components/ServiceDetailModal';
import { ServiceIllustration } from '../components/ServiceIllustrations';
import { services } from '../data/content';

function Service() {
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleReadMore = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  return (
    <>
      <section className="content-section page-section">
        <SectionHeader label="Our Services" title="What we deliver" />
        <div className="card-grid service-grid">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="service-card"
              style={{ borderTopColor: service.color }}
            >
              <div className="service-icon">
                <ServiceIllustration type={service.id} />
              </div>
              <h3>{service.category}</h3>
              <p className="service-summary">{service.description}</p>
              <div className="service-preview">
                <p className="preview-label">Key services:</p>
                <ul>
                  {service.preview.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              <button 
                className="link-button"
                onClick={() => handleReadMore(service)}
              >
                Read More
              </button>
            </div>
          ))}
        </div>
      </section>

      <ServiceDetailModal 
        service={selectedService}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}

export default Service;
